import { useWindowWidth } from '@react-hook/window-size/throttled'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'

import localStorageService from '@/services/localStorage.service'
import { desktopWidth } from '@/utils/constants'

type Props = {
  columns: any[]
  onColumnToggle: (column: string) => void
  toggles: { [key: string]: boolean }
}

const ToggleList = ({ columns, onColumnToggle, toggles }: Props) => {
  const windowWidth = useWindowWidth()
  const isDesktop = windowWidth >= desktopWidth

  return (
    <DropdownButton id='dropdown-item-button' title='Edit Columns'>
      {columns
        .filter((column) => column.dataField !== 'name')
        .map((column) => ({
          ...column,
          toggle: toggles[column.dataField],
        }))
        .map((column) => (
          <Dropdown.Item
            as='button'
            key={column.dataField}
            onClick={() => {
              localStorageService.setJSON(isDesktop ? 'edhrec_table_toggles' : 'edhrec_table_toggles_mobile', {
                ...toggles,
                [column.dataField]: !toggles[column.dataField],
              })
              onColumnToggle(column.dataField)
            }}
          >
            {toggles[column.dataField] ? (
              <span className='color-green me-2'>✓</span>
            ) : (
              <span className='color-red me-2'>✕</span>
            )}
            {column.text}
          </Dropdown.Item>
        ))}
    </DropdownButton>
  )
}

export default ToggleList
